import { Subject } from 'rxjs';

const sidelistView = {
    refinedByWidth: 20,
    refinedByMax: 30,
    refinedByMin: 10,

    previewWidth: 80,
    previewMax: 100,
    previewMin: 70,
};

interface LayoutViewType {
    refinedByWidth: number;
    refinedByMax: number;
    refinedByMin: number;

    previewWidth: number;
    previewMax: number;
    previewMin: number;
}

class CalendarLayoutConfig {
    isCollapsed: boolean;
    disableCollapse: boolean;
    actions$: Subject<any>;
    events$: Subject<any>;

    constructor(isCollapsed: boolean = false, disableCollapse: boolean = false) {
        this.isCollapsed = isCollapsed;
        this.disableCollapse = disableCollapse;
        this.actions$ = new Subject();
        this.events$ = new Subject();
    }
}
export enum CalendarLayoutActions {
    COLLAPSE_CHANGE = 'COLLAPSE_CHANGE',
    LAYOUT_CHANGE = 'LAYOUT_CHANGE'
}


export { sidelistView, LayoutViewType, CalendarLayoutConfig };
